<template>

    <div class="question__body" :class="{ '-locked': disabled }">
        <question-title :title="title" :sub-title="subTitle" :hashelp="hashelp" :uuid="uuid" :question-index="questionIndex"></question-title>

        <div class="choices checkbox-group" role="group" :aria-labelledby="'q_' + uuid">
            <div class="checkbox" v-for="(choice, index) of choices" :key="index">
                <checkbox-group-row
                    :question-index="questionIndex"
                    :choice="choice"
                    :uukey="uukey"
                    :triggers="triggers"
                    :answer="answer.answer"
                    :disabled="disabled"
                    :read-only="readOnly"
                ></checkbox-group-row>
            </div>
            <table class="checkbox-group--other">
                <matrix-other v-if="otherEnabled" :label="otherLabel" :instructions="otherInstructions" :uuid="uuid" :span="1" :othervalue="othervalue" :questionIndex="questionIndex"></matrix-other>
            </table>
        </div>
        <question-tip :questionTip="questionTip"></question-tip>
    </div>

</template>

<script>
import { isArray } from 'lodash';
import { questionMixin } from './mixins/question-mixin';
import { mapActions } from 'vuex';

export default {
    name: 'checkbox-group',

    mixins:[
        questionMixin,
    ],

    methods: {

        changeValue(state, rowID)
        {
            this.$store.dispatch('CHANGE_ANSWER', [this.uukey, state, rowID]);
        },

        changeOther($event)
        {
            this.changeValue($event.target.value, 'other');
            this.othervalue = $event.target.value;
        },

    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/checkbox-group.vue